import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Image = styled(GatsbyImage)<{ $aspectRatio: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  aspect-ratio: 16 / 9;
  cursor: pointer;
  background-color: black;

  ${({ $aspectRatio }) =>
    $aspectRatio
      ? `
    aspect-ratio: 16 / 9;
  `
      : `
    height: 100%;
  `}
`;

const Container = styled.div<{ $playing: boolean }>`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 21px;
  overflow: hidden;
  svg {
    position: absolute;
    width: 64px;
    height: 64px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    opacity: ${({ $playing }) => ($playing ? 0 : 1)};
    visibility: ${({ $playing }) => ($playing ? "hidden" : "visible")};
    cursor: pointer;

    path {
      fill: ${({ theme }) => theme.colors.red};
    }
  }

  ${Image} {
    opacity: ${({ $playing }) => ($playing ? 0 : 1)};
    visibility: ${({ $playing }) => ($playing ? "hidden" : "visible")};
  }
`;

const Iframe = styled.iframe<{ $aspectRatio: boolean }>`
  display: flex;
  width: 100%;

  border: none;
  background-color: black;
  padding-block: 16px;

  ${({ $aspectRatio }) =>
    $aspectRatio
      ? `
    aspect-ratio: 16 / 9;
  `
      : `
    height: 100%;
  `}
`;

const S = {
  Iframe,
  Image,
  Container,
};

export default S;
